class CreateSessionReq {
  constructor() {
    this.Id = undefined;
    this.Name = undefined;

    this.Description = undefined;
    this.Category = undefined;
    this.SecretName = undefined;
    this.EgyptianPrice = undefined;
    this.ArabPrice = undefined;
    this.OtherPrice = undefined;
    this.IsHalfDuration = undefined;
    this.IsAssessmentSession = undefined;
    this.Image = undefined;
    this.IsContractSession = undefined;
    this.ContractId = undefined;
    this.ParentSessionId = undefined;

    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined,
    };
  }
}

export default CreateSessionReq;
